/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestCodeQualityMessageSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_CODE_QUALITY_MESSAGE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class AutoTestCodeQualityMessageSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestCodeQualityMessageSettingParser.decode(input).map(res => new AutoTestCodeQualityMessageSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestCodeQualityMessageSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestCodeQualityMessageSettingParser.encode(data);
    }
    static schema() {
        return AutoTestCodeQualityMessageSettingParser.schema();
    }
}
